import { useState, useCallback } from 'react';
import type { LoginFormProps } from './types';

export const LoginForm = ({ apiUrl, onLoginSuccess }: LoginFormProps) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loggingIn, setLoggingIn] = useState(false);
  const [loginError, setLoginError] = useState('');

  const handleLogin = useCallback(async () => {
    if (!email || !password) {
      setLoginError('Email and password are required');
      return;
    }

    setLoggingIn(true);
    setLoginError('');

    try {
      const baseUrl = apiUrl.replace(/\/+$/, '');
      const res = await fetch(`${baseUrl}/api/users/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) {
        setLoginError(`Login failed (${res.status})`);
        return;
      }

      const data = await res.json();
      onLoginSuccess(data.token, data.refreshToken);
      setLoginError('');
    } catch (err) {
      setLoginError((err as Error).message);
    } finally {
      setLoggingIn(false);
    }
  }, [email, password, apiUrl, onLoginSuccess]);

  const inputClass =
    'bg-[#0d1117] border border-[#30363d] text-[#c9d1d9] px-2.5 py-2 rounded-md text-sm font-mono w-full focus:outline-none focus:border-[#58a6ff]';
  const btnBase =
    'px-5 py-2.5 rounded-md font-semibold text-sm text-white cursor-pointer transition-opacity disabled:opacity-50 disabled:cursor-not-allowed';

  return (
    <div>
      <div className="flex gap-3 mb-2.5 flex-wrap">
        <div className="flex-1 min-w-[140px]">
          <label className="block text-[12px] text-[#8b949e] mb-1">
            Email
          </label>
          <input
            type="email"
            className={inputClass}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@example.com"
          />
        </div>
        <div className="flex-1 min-w-[140px]">
          <label className="block text-[12px] text-[#8b949e] mb-1">
            Password
          </label>
          <input
            type="password"
            className={inputClass}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="password"
          />
        </div>
        <div className="flex items-end">
          <button
            className={`${btnBase} bg-[#1f6feb] hover:opacity-85`}
            onClick={handleLogin}
            disabled={loggingIn}
          >
            {loggingIn ? 'Logging in...' : 'Login'}
          </button>
        </div>
      </div>
      {loginError && (
        <div className="text-[11px] text-[#f85149] mb-2">{loginError}</div>
      )}
    </div>
  );
};
